import DashBoardNavigationArray from "./TeachersDashBoardNavigationArray";
import CommonDashboard from "@components/CommonDashboard";
function TeacherDashBoard() {
  return (
    <CommonDashboard DashBoardNavigationArray={DashBoardNavigationArray} />
  );
}

export default TeacherDashBoard;
